import { render } from "./WonderActivation.vue?vue&type=template&id=72c5ed7b"
import script from "./WonderActivation.vue?vue&type=script&lang=js"
export * from "./WonderActivation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__